import { plainToInstance } from 'class-transformer'
import i18n from 'vue-i18n'

import {
  HttpMethodEnum,
  HttpRequest,
  HttpResponseTypeEnum
} from "../../../../../../../../shared/types/HttpRequest";
import { MenuSectionNames, SocketNames } from '../../../../../components'
import { BaseNodeModelData } from '../../../BaseNode/BaseNodeDataModel'
import { BaseNodeModel } from '../../../BaseNode/BaseNodeModel'
import { CustomNode, CustomNodeComponent, NodeTypes } from '../../../index'
import HttpRequestSampleNode from '../ui/SampleNode/HttpRequestSampleNode.vue'
import HttpRequestSidebar from '../ui/Sidebar/HttpRequestSidebar.vue'
import { HttpRequestNodeProps } from './types'

export default class HttpRequestNodeBuilder extends CustomNodeComponent {
  menuSection = MenuSectionNames.Additionally
  sidebarComponent = HttpRequestSidebar

  constructor(i18n: i18n, nodeProps: HttpRequestNodeProps) {
    super(HttpRequestSampleNode, HttpRequestNode, NodeTypes.HttpRequest, i18n, nodeProps)
  }

  getBaseNodeModel = ([ x, y ]: [ number, number ]) => {
    return {
      data: plainToInstance(HttpRequestNodeData, {
        type: NodeTypes.HttpRequest,
        url: '',
        method: HttpMethodEnum.Post,
        headers: {},
        body: '',
        form: null,
        response_type: HttpResponseTypeEnum.Json,
        mapper: {},
        fail_output: CustomNode.LastSocketId += 1
      }),
      output: CustomNode.LastSocketId += 1,
      input: CustomNode.LastSocketId += 1,
      color: null,
      x,
      y,
    }
  }
}

export class HttpRequestNode extends CustomNode {
  data: HttpRequestNodeData

  declare nodeProps: HttpRequestNodeProps

  constructor(name: NodeTypes.HttpRequest, model: BaseNodeModel, nodeProps: HttpRequestNodeProps) {
    super(name, model, nodeProps)

    if (model.data instanceof HttpRequestNodeData) {
      this.data = model.data

      this.socketActions.createOutput(model.data.fail_output, SocketNames.Fail)
    } else {
      throw new Error('To node come unknown data')
    }
  }
}

export class HttpRequestNodeData extends BaseNodeModelData {
  declare type: NodeTypes.HttpRequest

  url!: HttpRequest['url']
  method!: HttpRequest['method']
  headers!: HttpRequest['headers']
  body?: HttpRequest['body']
  form?: HttpRequest['form']
  response_type!: HttpRequest['response_type']
  mapper?: Record<string, string>
  fail_output!: number
}
